import React, { useState, useEffect } from 'react';
import TagManager from 'react-gtm-module';
import queryString from 'query-string';
import WithProduct from './WithProduct';
import WithoutProduct from './WithoutProduct';
import CampaignHeader from '../../../components/Campanhas/CampaignHeader';

const Painel = ({ location }) => {
	const [hasProduct, setHasProduct] = useState(true);

	const pageName = [
		'Home sem produto',
		'Home com produto',
	];

    useEffect(() => {
        const queryStringData = (queryString.parse(location.search));
		setHasProduct(queryStringData.hasProduct);
		TagManager.dataLayer({
			dataLayer: {
				event: 'PageView',
				page: pageName[queryStringData.hasProduct ? 1 : 0],
			},
			dataLayerName: 'Campanhas',
		});
    }, []);

    return hasProduct ? (
	<>
		<CampaignHeader>Campanhas</CampaignHeader>
		<div style={{ padding: '33px 30px' }}>
			<WithProduct />
		</div>
	</>
        ) : (
	<>
		<div style={{ padding: '33px 30px' }}>
			<WithoutProduct />
		</div>
	</>
    );
};

export default Painel;
